import {
  Fingerprint, CalendarDays, Megaphone, ClipboardCheck, BarChart3, Users,
  BookUser, Network, FileText, GraduationCap, Gift, ShieldCheck, Settings,
  Timer, Laptop, Baby, Plane, BadgeCheck, CalendarRange, Wallet, TrendingUp,
  BookOpen, Sparkles, Archive, CalendarClock, CalendarCheck2, Stamp,
} from "lucide-react";
import { PAYSLIP_PORTAL_URL } from "./config";

// Registro centrale delle voci di navigazione.
// need: undefined = tutti (interni/esterni salvo internalOnly) | "approver" | "admin"
export const NAV = {
  presenze:      { label: "Timbratura", icon: Fingerprint, to: "/presenze", hidden: true, internalOnly: true, hideEmployee: true, color: "#5c6bc0", desc: "Timbra entrata/uscita e registro presenze" },
  ferie:         { label: "Ferie e Permessi", icon: CalendarDays, to: "/ferie", internalOnly: true, color: "#009640", desc: "Richiedi e monitora le assenze" },
  comunicazioni: { label: "Comunicazioni", icon: Megaphone, to: "/comunicazioni", color: "#e30613", desc: "Bacheca e avvisi aziendali" },
  approvazioni:  { label: "Approvazioni", icon: ClipboardCheck, to: "/approvazioni", need: "approver", color: "#009640", desc: "Richieste del team da approvare" },
  report:        { label: "Report", icon: BarChart3, to: "/report", need: "admin", color: "#8e44ad", desc: "Cruscotto, prospetto presenze e statistiche" },
  admin:         { label: "Gestione HR", icon: Users, to: "/admin", need: "admin", color: "#0d6cb8", desc: "Anagrafiche dipendenti, reparti e sedi" },

  // Gestione archivi (anagrafiche / dati di base)
  rubrica:       { label: "Rubrica", icon: BookUser, to: "/rubrica", color: "#16345c", desc: "Contatti dei colleghi" },
  organigramma:  { label: "Organigramma", icon: Network, to: "/organigramma", color: "#0d6cb8", desc: "Struttura e reparti" },
  documenti:     { label: "Documenti", icon: FileText, to: "/documenti", color: "#8e44ad", desc: "Contratti e certificazioni" },
  formazione:    { label: "Formazione", icon: GraduationCap, to: "/formazione", internalOnly: true, hideEmployee: true, color: "#c0392b", desc: "Corsi e percorsi aziendali" },
  welfare:       { label: "Welfare e Benefit", icon: Gift, to: "/welfare", color: "#009640", desc: "Convenzioni e beni assegnati" },
  policy:        { label: "Policy Assenze", icon: ShieldCheck, to: "/policy", need: "admin", color: "#c0392b", desc: "Regole e configurazione" },
  carteintestate:{ label: "Carta Intestata", icon: Stamp, to: "/carta-intestata", need: "admin", color: "#0d6cb8", desc: "Intestazione degli attestati PDF per società" },
  profilo:       { label: "Profilo", icon: Settings, to: "/profilo", color: "#607d8b", desc: "Dati personali e preferenze" },

  // Elaborazioni quotidiane (operatività giornaliera)
  straordinari:  { label: "Straordinari", icon: Timer, to: "/straordinari", internalOnly: true, hideEmployee: true, color: "#e67e22", desc: "Registra le ore extra" },
  smartworking:  { label: "Smart Working", icon: Laptop, to: "/smart-working", internalOnly: true, hideEmployee: true, color: "#00838f", desc: "Giornate da remoto" },
  congedi:       { label: "Congedi e Maternità", icon: Baby, to: "/congedi", internalOnly: true, color: "#e91e8c", desc: "Congedi parentali e Legge 104" },
  trasferte:     { label: "Trasferte e Note Spese", icon: Plane, to: "/trasferte", internalOnly: true, color: "#0d6cb8", desc: "Rimborsi e missioni" },
  certificati:   { label: "Certificati di Malattia", icon: BadgeCheck, to: "/certificati", internalOnly: true, color: "#009640", desc: "Carica e consulta i certificati" },
  calendario:    { label: "Calendario Team", icon: CalendarRange, to: "/calendario", internalOnly: true, color: "#8e44ad", desc: "Assenze approvate del team" },

  // Elaborazioni mensili (chiusure e riepiloghi)
  bustepaga:     { label: "Buste Paga", icon: Wallet, href: PAYSLIP_PORTAL_URL, external: true, internalOnly: true, color: "#16345c", desc: "Vai al portale cedolini" },
  maturazioni:   { label: "Maturazioni ratei", icon: TrendingUp, to: "/admin", need: "admin", color: "#0d6cb8", desc: "Ratei ferie/ROL mensili (Gestione HR)" },

  // Extra / supporto
  guida:         { label: "Guida", icon: BookOpen, to: "/guida", color: "#16345c", desc: "Manuale d'uso del portale" },
  novita:        { label: "Novità", icon: Sparkles, to: "/novita", color: "#ff7e00", desc: "Aggiornamenti del portale" },
};

// Definizione dei 3 macro-menù (ordine voci incluso)
export const MACROS = [
  { key: "archivi", label: "Gestione Archivi", short: "Archivi", icon: Archive, items: ["admin", "rubrica", "organigramma", "documenti", "formazione", "welfare", "policy", "carteintestate", "profilo"] },
  { key: "quotidiane", label: "Elaborazioni Quotidiane", short: "Quotidiane", icon: CalendarClock, items: ["presenze", "ferie", "straordinari", "smartworking", "congedi", "trasferte", "certificati", "calendario", "comunicazioni", "approvazioni"] },
  { key: "mensili", label: "Elaborazioni Mensili", short: "Mensili", icon: CalendarCheck2, items: ["bustepaga", "report", "maturazioni"] },
];

const allowed = ({ isAdmin, isApprover, isExternal, isEmployee }) => (item) => {
  if (!item || item.hidden) return false;
  if (item.internalOnly && isExternal) return false;
  if (item.hideEmployee && isEmployee) return false;
  if (item.need === "admin" && !isAdmin) return false;
  if (item.need === "approver" && !isApprover) return false;
  return true;
};

// Costruisce la navigazione filtrata per ruolo.
export function buildNav(flags) {
  const ok = allowed(flags);
  const resolve = (keys) => keys.map((k) => ({ key: k, ...NAV[k] })).filter(ok);
  const quickKeys = flags.isApprover
    ? ["approvazioni", "report", "admin", "comunicazioni"]
    : ["presenze", "ferie", "comunicazioni"];
  return {
    quick: resolve(quickKeys),
    macros: MACROS.map((m) => ({ ...m, items: resolve(m.items) })).filter((m) => m.items.length > 0),
    extra: resolve(["guida", "novita"]),
  };
}

// Tutte le voci accessibili all'utente (per ricerca globale e personalizzazione accessi rapidi).
export function accessibleItems(flags) {
  const ok = allowed(flags);
  return Object.keys(NAV).map((k) => ({ key: k, ...NAV[k] })).filter(ok);
}

// Risolve una lista di chiavi in voci NAV accessibili (mantiene l'ordine, scarta le non consentite).
export function resolveKeys(keys, flags) {
  const ok = allowed(flags);
  return (keys || []).map((k) => (NAV[k] ? { key: k, ...NAV[k] } : null)).filter(Boolean).filter(ok);
}
